import React from 'react';
import unitIcon from './assets/unit.svg';
import generatorIcon from './assets/generator.svg';
import { toolIcons } from '@starflow/app/constants';

const iconMap = {
  unit: unitIcon, // 独立工作单元icon
  generator: generatorIcon, // 生成器icon
  ...toolIcons,
};

const FlowNodeIcon = React.memo(({ isSelected, type = 'multi' }) => {
  return (
    <div
      className={`w-[16px] h-[16px] flex-shrink-0 flex justify-center items-center rounded-[2px] ${
        isSelected ? 'bg-primary' : 'bg-[#4A4B4C]'
      }`}
      style={{
        boxShadow: isSelected ? '0px 1px 2px 0px rgba(0, 157, 255, 0.30)' : '0px 1px 2px 0px rgba(70, 85, 94, 0.15)',
      }}
    >
      <img className="w-[12px] h-[12px]" src={iconMap[type] || iconMap.generator} alt="icon" />
    </div>
  );
});

export default FlowNodeIcon;
